module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("79uuG"))).then(() => module.bundle.root('hEqeo'));